module.exports = __webpack_public_path__ + "static/img/pie-chart-7.71c14e18.svg";